import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import MUIModal from '../../../common/MUIModal';
import Pods from './Pods';

/**
 * PoD column for the PTL shipment lists: "View (n)" opens the shipment's PoD files in the same "PODs Link" pop-up as
 * Delivered shipments; "—" when none is uploaded yet. Uses the row's own `pods`, so no extra call.
 */
export default function PodViewCell({ row }) {
  const [open, setOpen] = useState(false);
  const count = row?.pods?.length || 0;
  if (!count) return <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>—</Typography>;
  return (
    <>
      <Button size='small' variant='outlined' onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        startIcon={<OpenInNewOutlined sx={{ fontSize: 14 }} />}
        sx={{ textTransform: 'none', fontSize: 12, fontWeight: 600, py: 0.25, whiteSpace: 'nowrap' }}>
        View{count > 1 ? ` (${count})` : ''}
      </Button>
      <MUIModal open={open} handleClose={() => setOpen(false)} title='PODs Link'>
        <Pods id={row} />
      </MUIModal>
    </>
  );
}
